export type Direction = 'up' | 'down' | 'left' | 'right';
export type CharacterState = 'idle' | 'walk' | 'place-bomb' | 'death' | 'victory';
export const ATLAS = 'summer';
export const directions: Direction[] = ['up', 'down', 'left', 'right'];
export const dogNames: Record<string, string> = { basic: 'normal', fast: 'fast', hunter: 'hunter', smart: 'smart', bomber: 'bomber', boss: 'boss' };
// Only verified poses are sequenced together; missing orientations are declared here.
export function characterFrames(character: string, state: CharacterState, direction: Direction): { frames: string[]; flip: boolean } {
  if (character === 'penguin') {
    const counts: Record<string, number> = { idle:4, 'walk-up':6, 'walk-down':3, 'walk-left':5, 'walk-right':6, 'place-bomb':2, death:2, victory:2 };
    const group = state === 'walk' ? `walk-${direction}` : state === 'idle' && direction !== 'down' ? `walk-${direction}` : state;
    const count = state === 'idle' && direction !== 'down' ? 1 : counts[group];
    return { frames:Array.from({length:count},(_,i)=>`penguin/${group}/${i}`), flip:false };
  }
  if (character === 'walker') {
    const counts: Record<string, number> = { idle:1, 'walk-up':4, 'walk-down':2, 'walk-left':3, 'walk-right':6, 'place-bomb':2, death:2, victory:2 };
    const group = state === 'walk' ? `walk-${direction}` : state === 'idle' && direction !== 'down' ? `walk-${direction}` : state;
    const count = state === 'idle' && direction !== 'down' ? 1 : counts[group];
    return { frames:Array.from({length:count},(_,i)=>`walker/${group}/${i}`), flip:false };
  }
  if (character.startsWith('penguin-') || character.startsWith('walker-')) {
    // The new sheets provide one original pose per pursuer variant.
    const type = character.slice(character.indexOf('-')+1);
    return {frames:[`dogs/${dogNames[type]}/front`],flip:false};
  }
  if (character.startsWith('winter-')) {
    return characterFrames(character.slice(7), state, direction);
  }
  if (character === 'cat') {
    const counts: Record<string, number> = { idle: 3, 'walk-up': 3, 'walk-down': 3, 'walk-left': 4, 'walk-right': 4, 'place-bomb': 2, death: 2, victory: 2 };
    const group = state === 'walk' ? `walk-${direction}` : state === 'idle' && direction !== 'down' ? `walk-${direction}` : state;
    const count = state === 'idle' && direction !== 'down' ? 1 : counts[group];
    return { frames: Array.from({ length: count }, (_, i) => `cat/${group}/${i}`), flip: false };
  }
  const name = dogNames[character] ?? character;
  // Dogs have left-facing side poses. Boss has front views only.
  const pose = name === 'boss' ? 'front' : direction === 'up' ? 'back' : direction === 'down' ? 'front' : 'side';
  return { frames: [`dogs/${name}/${pose}`], flip: name !== 'boss' && direction === 'right' };
}
export function animationKey(character: string, state: CharacterState, direction: Direction): string { return `${character}:${state}:${direction}`; }
